import React from 'react';
import styled from 'styled-components';

const LocationsSection = () => {
  return (
    <Section>
      <ContentWrapper>
        <TextContent>
          <SectionLabel>Locations</SectionLabel>
          <Title>Find us near you</Title>
            {/* <Description>
              Visit our locations across Texas. Experience the future of basketball analytics and training, right in your neighborhood.
            </Description> */}
        </TextContent>
        <MapContainer>
          <iframe
            title="Akiture Basketball Court Locations Map"
            src="https://www.google.com/maps/d/u/0/embed?mid=12avFMj2EBdv5CmxpPm4xoCOGCmK3HoA&ehbc=2E312F&noprof=1"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </MapContainer>
      </ContentWrapper>
    </Section>
  );
};

export default LocationsSection;

const Section = styled.section`
  padding: ${({ theme }) => theme.spacing.xl} 0;
  background-color: ${({ theme }) => theme.colors.primaryBackground};
  position: relative;
  overflow: hidden;

  @media (max-width: 320px) {
    padding: ${({ theme }) => theme.spacing.md} 0;
  }

  @media (min-width: 321px) and (max-width: 375px) {
    padding: ${({ theme }) => theme.spacing.lg} 0;
  }

  @media (min-width: 376px) and (max-width: 480px) {
    padding: ${({ theme }) => theme.spacing.xl} 0;
  }
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spacing.lg};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xl};

  @media (max-width: 320px) {
    padding: 0 ${({ theme }) => theme.spacing.sm};
    gap: ${({ theme }) => theme.spacing.md};
  }

  @media (min-width: 321px) and (max-width: 375px) {
    padding: 0 ${({ theme }) => theme.spacing.md};
    gap: ${({ theme }) => theme.spacing.lg};
  }

  @media (min-width: 376px) and (max-width: 480px) {
    padding: 0 ${({ theme }) => theme.spacing.lg};
    gap: ${({ theme }) => theme.spacing.xl};
  }
`;

const TextContent = styled.div`
  max-width: 520px;
  margin: 0 auto;
  text-align: center;
`;

const SectionLabel = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  text-transform: uppercase;
  letter-spacing: 0.15em;
  color: ${({ theme }) => theme.colors.accentPrimary};
  margin-bottom: ${({ theme }) => theme.spacing.xs};
  font-weight: 600;
  opacity: 0.9;
`;

const Title = styled.h2`
  font-size: ${({ theme }) => theme.fontSizes['3xl']};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0 0 ${({ theme }) => theme.spacing.xl} 0;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  position: relative;

  &::after {
    content: '';
    display: block;
    width: 40px;
    height: 2px;
    background: ${({ theme }) => theme.colors.accentPrimary};
    margin: ${({ theme }) => theme.spacing.sm} auto 0;
    border-radius: ${({ theme }) => theme.borderRadius.full};
  }

  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.fontSizes['2xl']};
    margin-bottom: ${({ theme }) => theme.spacing.lg};
  }

  @media (max-width: 480px) {
    font-size: ${({ theme }) => theme.fontSizes.xl};
    margin-bottom: ${({ theme }) => theme.spacing.md};
  }
`;

const Description = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.xl};
  color: ${({ theme }) => theme.colors.textSecondary};
  margin: 0;
  line-height: 1.7;
  letter-spacing: -0.01em;

  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.fontSizes.lg};
    line-height: 1.6;
  }

  @media (max-width: 480px) {
    font-size: ${({ theme }) => theme.fontSizes.md};
    line-height: 1.5;
  }
`;

const MapContainer = styled.div`
  width: 100%;
  max-width: 800px;
  height: 400px;
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);

  @media (max-width: 320px) {
    height: 250px;
    border-radius: ${({ theme }) => theme.borderRadius.md};
  }

  @media (min-width: 321px) and (max-width: 375px) {
    height: 300px;
    border-radius: ${({ theme }) => theme.borderRadius.md};
  }

  @media (min-width: 376px) and (max-width: 480px) {
    height: 350px;
  }
`; 